module.exports = __webpack_public_path__ + "static/media/remove_book_2.02728908.png";